module.exports = __webpack_public_path__ + "static/media/icon-delete.e2ab5663.svg";